<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex flex-col justify-between">
			<div class="xs:p-2 flex overflow-hidden p-0">
				<HelpfulTips>
					Please select the dealership where you'd like to trade-in your Honda. Not sure
					about your next vehicle yet? No problem - you can make that decision later!
				</HelpfulTips>

				<div class="grow basis-1/2 overflow-y-auto px-4">
					<div
						v-for="office in config.getOffices"
						:key="office.id"
						class="hover:border-main-300 hover:bg-main-300 group mx-auto mb-4 box-border flex w-auto cursor-pointer flex-col items-start rounded-xl border border-gray-300 px-4 py-3 ease-in-out lg:py-4"
						:class="{
							'border-main-400 bg-main-400 text-white':
								form.selectedOffice === office.id,
						}"
						@click="onSelectOffice(office)"
					>
						<div class="flex w-full items-center justify-between">
							<div class="flex flex-col">
								<div class="flex items-center justify-between">
									<div
										class="text-md text-main-400 mb-2 text-left font-bold ease-in-out group-hover:text-white lg:mb-2 lg:text-xl"
										:class="{
											'!text-white': form.selectedOffice === office.id,
										}"
									>
										<p>
											{{
												office.is_main
													? config.config.location?.dealership_name
													: office.name
											}}
										</p>
										<div class="flex"></div>
									</div>
								</div>

								<div
									class="lg:text:base text-secondary text-[14px] group-hover:text-white"
									:class="{
										'!text-white': form.selectedOffice === office.id,
									}"
								>
									{{ office.address }}
									<br />
									{{ office.city }}, {{ office.state }} {{ office.zip }}
								</div>
							</div>

							<MarkerSvg class="fill-success-base h-10 w-[28px]" />
						</div>
					</div>

					<div
						class="hover:border-main-300 hover:bg-main-300 group mx-auto mb-4 box-border flex w-auto cursor-pointer flex-col items-start rounded-xl border border-gray-300 px-4 py-3 ease-in-out lg:py-4"
						:class="{
							'border-main-400 bg-main-400 text-white':
								form.selectedOffice === undefined,
						}"
						@click="onSelectOffice(undefined)"
					>
						<div class="flex w-full items-center justify-between">
							<div class="flex flex-col">
								<div class="flex items-center justify-between">
									<div
										class="text-md text-main-400 text-left font-bold ease-in-out group-hover:text-white lg:text-xl"
										:class="{
											'!text-white': form.selectedOffice === undefined,
										}"
									>
										<p>I'm not sure</p>
										<div class="flex"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useConfigStore } from '../../../stores/config'
	import { Steps, useFormStore } from '../../../stores/form'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import { onMounted } from 'vue'
	import MarkerSvg from '../components/icons/MarkerSvg.vue'
	import { Office } from '../../../stores/form'

	const config = useConfigStore()
	const form = useFormStore()

	onMounted(() => {
		config.getOffices?.length === 0 && form.setStep(Steps.ContactInfo)
	})

	const onSelectOffice = (office?: Office): void => {
		office === undefined ? (form.selectedOffice = office) : (form.selectedOffice = office.id)
	}
</script>
